module.exports = __webpack_public_path__ + "img/doc_edit.48ecb0f0.svg";